var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSellFill0Wght400Grad0Opsz481(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.95 43.15C27.35 43.75 26.625 44.05 25.775 44.05C24.925 44.05 24.2 43.75 23.6 43.15L4.85 24.4C4.51667 24.0667 4.29167 23.7167 4.175 23.35C4.05833 22.9833 4 22.6 4 22.2V7C4 6.13333 4.28333 5.41667 4.85 4.85C5.41667 4.28333 6.13333 4 7 4H22.2C22.6 4 23 4.05833 23.4 4.175C23.8 4.29167 24.1667 4.51667 24.5 4.85L43.15 23.5C43.7833 24.1333 44.1 24.875 44.1 25.725C44.1 26.575 43.7833 27.3167 43.15 27.95L27.95 43.15ZM25.9 41.1L41.1 25.9L22.2 7H7V22.2L25.9 41.1ZM12.25 14.8C12.95 14.8 13.5583 14.5417 14.075 14.025C14.5917 13.5083 14.85 12.9 14.85 12.2C14.85 11.5 14.5917 10.8917 14.075 10.375C13.5583 9.85833 12.95 9.6 12.25 9.6C11.55 9.6 10.9417 9.85833 10.425 10.375C9.90833 10.8917 9.65 11.5 9.65 12.2C9.65 12.9 9.90833 13.5083 10.425 14.025C10.9417 14.5417 11.55 14.8 12.25 14.8Z",
    fill: "#6CD11C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellFill0Wght400Grad0Opsz481);
export default __webpack_public_path__ + "static/media/sell_FILL0_wght400_GRAD0_opsz48 1.4daf1d99aeda305bbbe3c22ece83679d.svg";
export { ForwardRef as ReactComponent };